<div  [ngClass]="{'inline': flexDirection === 'inline'}" *ngFor="let language of languages">
    <div class="flag">
        <mat-icon [svgIcon]="getFlagForLanguage(language.shortName)"></mat-icon>
        <span *ngIf="showFullName"> {{ language.fullName }}</span>
    </div>
</div>
